import { useState, useEffect } from 'react';

const useEntityManagement = (entities, filterAllEntitiesOption = false) => {
  const [entitiesList, setEntitiesList] = useState([]);

  useEffect(() => {
    if (entities) {
      const sortedEntities = [...entities]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => ({
          label: item.name,
          value: item,
        }));
      filterAllEntitiesOption
        ? setEntitiesList(sortedEntities)
        : setEntitiesList([{ label: 'All entities' }, ...sortedEntities]);
    }
  }, [entities, filterAllEntitiesOption]);

  return entitiesList;
};

export default useEntityManagement;
